import { OCRActivityLog } from '@/service/gpu-instance/ocr-type';
import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { Badge } from '@/components/ui/badge';

export const columns: ColumnDef<OCRActivityLog>[] = [
  {
    accessorKey: 'timestamp',
    header: 'Timestamp',
    cell: ({ row }) => {
      return (
        <span className="whitespace-nowrap">
          {dayjs(row.getValue('timestamp')).format('DD MMM YYYY, HH:mm:ss')}
        </span>
      );
    },
    size: 170,
  },
  {
    accessorKey: 'request_id',
    header: 'Request ID',
    cell: ({ row }) => {
      const requestId = row.getValue('request_id') as string;
      return (
        <span className="font-mono text-xs" title={requestId}>
          {requestId.slice(0, 16)}...
        </span>
      );
    },
    size: 150,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const status = row.getValue('status') as string;
      return (
        <Badge
          variant={status === 'success' ? 'default' : 'destructive'}
          className="capitalize"
        >
          {status}
        </Badge>
      );
    },
    size: 90,
  },
  {
    accessorKey: 'document_type',
    header: 'Document Type',
    cell: ({ row }) => {
      return <span>{row.getValue('document_type')}</span>;
    },
    size: 130,
  },
  {
    accessorKey: 'file_name',
    header: 'File Name',
    cell: ({ row }) => {
      const fileName = row.getValue('file_name') as string;
      return (
        <span className="max-w-[150px] truncate" title={fileName}>
          {fileName}
        </span>
      );
    },
    size: 150,
  },
  {
    accessorKey: 'latency_ms',
    header: () => <div className="text-right">Latency</div>,
    cell: ({ row }) => {
      const latency = row.getValue('latency_ms') as number;
      return (
        <div className="text-right">
          {latency.toLocaleString()} ms
        </div>
      );
    },
    size: 100,
  },
  {
    accessorKey: 'tokens_used',
    header: () => <div className="text-right">Tokens</div>,
    cell: ({ row }) => {
      const tokens = row.getValue('tokens_used') as number;
      return (
        <div className="text-right">
          {tokens.toLocaleString()}
        </div>
      );
    },
    size: 80,
  },
  {
    accessorKey: 'error_message',
    header: 'Error',
    cell: ({ row }) => {
      const errorMessage = row.getValue('error_message') as string | undefined;
      if (!errorMessage) return <span className="text-muted-foreground">-</span>;
      return (
        <span className="text-destructive text-sm" title={errorMessage}>
          {errorMessage}
        </span>
      );
    },
    size: 150,
  },
];
